// Models
import Model from './Model'

class TierWatchdogRule extends Model {
  get schema () {
    return [
      'ruleId',
      'ruleName',
      'ruleCode',
      'ruleType',
      'disabled',
      'ibanWhitelist'
    ]
  }
}

export default TierWatchdogRule
